<template>
  <form id="browse-form" class="browse-form u-clearfix" v-on:submit.prevent="(event) => submitHandler(event, submit)">
    <h3 v-if="mode === 'default'" class="browse-form__header">Browse for a code</h3>
    <SelectTag 
      :value="industry"
      :options="industryOptions"
      :loading="industryLoading"
      :change="industryChange"
      placeholder="Select your industry"
      name="industry"
      class="browse-form__select browse-form__industry"
    />
    <SelectTag 
      :value="sector"
      :options="sectorOptions"
      :loading="sectorLoading"
      :change="sectorChange"
      placeholder="Select your sector"
      name="sector"
      class="browse-form__select browse-form__sector"
    />
    <SelectTag 
      :value="category"
      :options="categoryOptions"
      :loading="categoryLoading"
      :change="categoryChange"
      placeholder="Select your category"
      name="category"
      class="browse-form__select browse-form__category"
    />
    <button type="submit" class="browse-form__button u-pull-right" form="browse-form" :disabled="!category"
      data-gtm-category="Browse" data-gtm-action="Submit" :data-gtm-label="label">Go</button>
    
    <div class="browse-form u-clearfix"></div>
    <div v-if="mode === 'browse' && !nbResults" class="browse-form_help">
      <div v-if="routeName === 'division' || routeName === 'industry'" class="help">
        <p>Starting with the suggested selection/s above, continue to make selections based on the goods or services your business produces or sells. 
          If you are self-employed, make selections based on what you do.</p>
      </div>
      <div v-if="routeName !== 'division' && routeName !== 'industry'" class="help">
        <p>Select your industry. For example, if you are a builder, select ‘construction’ and then make selections based on the goods or services your business produces or sells.</p>
        <p>If you are self-employed, make selections based on what you do.</p>
        <p>Need help? Read more about <a href="/help/">BIC codes →</a></p>
      </div>   
    </div>
  </form>
</template>

<script>
  import Vue from 'vue';
  import SelectTag from './SelectTag.vue';
  import dataHelper from '../services/data-helper.js';

  export default Vue.component('BrowseForm', {
    props: {
      mode: String,
      nbResults: Number,
      routeName: String,
      industry: String,
      industryOptions: Array,
      sector: String,
      sectorOptions: Array,
      category: String,
      categoryOptions: Array,
      industryLoading: Boolean,
      sectorLoading: Boolean,
      categoryLoading: Boolean,
      submit: Function,
      industryChange: Function,
      sectorChange: Function,
      categoryChange: Function,
    },
    computed: {
      label: function() {
        return `${dataHelper.getNameById(this.industryOptions, this.industry)} >> ${dataHelper.getNameById(this.sectorOptions, this.sector)} >> ${dataHelper.getNameById(this.categoryOptions, this.category)}`;
      }
    },
    methods: {
      submitHandler: function(event) {
        this.submit({ category: this.category });
      }
    }
  });
</script>
